import { Modal as ReactstrapModal, ModalBody } from 'reactstrap';
import styled from 'styled-components';

export const Modal = ({
	isOpen,
	toggleHandler,
	children,
	size,
	keyboard,
	backdrop
}: ModalProps): JSX.Element => {
	return (
		<ModalContainer
			isOpen={isOpen}
			toggle={() => toggleHandler()}
			size={size}
			keyboard={keyboard}
			backdrop={backdrop}
		>
			<ModalContent>{children}</ModalContent>
		</ModalContainer>
	);
};

export interface ModalProps {
	isOpen: boolean;
	toggleHandler: () => void;
	children?:
		| React.ReactNode
		| JSX.Element
		| React.ReactNode[]
		| JSX.Element[];
	size?: string;
	keyboard?: boolean;
	backdrop?: boolean | 'static';
}

const ModalContainer = styled(ReactstrapModal)`
	margin: 48px auto;

	width: fit-content;
	@media (max-width: 600px) {
		max-width: 90%;
	}
`;

const ModalContent = styled(ModalBody)`
	padding: 16px;

	p {
		font-size: 16px;
		font-weight: bold;
		color: #575757;
		margin-bottom: 24px;
	}

	@media (max-width: 768px) {
		min-width: 320px;
		padding: 16px;
	}

	@media (max-width: 600px) {
		min-width: 320px;
		padding: 16px;
	}

	@media (max-width: 350px) {
		min-width: auto;
		padding: 16px;
	}
`;
